import {Col, Form, Input, Row, Select} from 'antd';
import React from 'react';
import AddFormComponent from '../common/AddFormComponent';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const AddMemberCompany = () => {
	const currentUrl = window.location.href;
	const apiList = [Arguments.host + '/society_organization/society/api!addMemberCompany.do'];

	return (
		currentUrl.endsWith('add') ? <AddFormComponent UserForm={MemberCompanyForm} url={apiList}/>
			: <EditFormComponent UserForm={MemberCompanyForm} url={apiList}/>
	);
};
const MemberCompanyForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="memberUnitName" label="单位名称"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberUnitAttribute" label="单位性质"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="党政机关">
						<Select>
							<Select.Option value="党政机关">党政机关</Select.Option>
							<Select.Option value="事业单位">事业单位</Select.Option>
							<Select.Option value="企业">企业</Select.Option>
							<Select.Option value="其他">其他</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberUnitCorporation" label="法定代表人"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="memberUnitAddress" label="单位地址"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberUnitMeetingPeople" label="联系人"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberUnitMeetingPeoplePhone" label="联系电话"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddMemberCompany;
